import NavigationFavorite from './NavigationFavorite';

export default NavigationFavorite;
